<template>
   <div class="edit-course-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12 padding-right-0Point5Perc">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="udpateCloseEditCourseDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Title
                </div>
                <div class="font-size-15px col-md-8 col-lg-8 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="CourseTitleValue" :maxlength="titleMaxLength">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Sub-Title
                </div>
                <div class="font-size-15px col-md-8 col-lg-8 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="CourseSubTitleValue" :maxlength="subTitleMaxLength">
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2">
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Version
                </div>
                <div class="font-size-15px col-md-4 col-lg-4 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="CourseVersionValue">
                    </div>
                  </div>
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-left-0Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                  Course Type
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="CourseTypeValue">
                        <option value=0>Normal</option>
                        <option value=1>Mentora Moments</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>  
              </div>
              <div class="row vertical-align" v-if="isComingFrom === constants.CourseSearchBarEnum.Course"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Toolkit File
                </div>
                <div class="font-size-15px col-md-8 col-lg-8 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-3" v-if="ToolkitFileUrlValue !== null && ToolkitFileUrlValue !== undefined">
                      <span v-if="(parseInt(courseObj.DeleteToolKitAndImage) !== parseInt(constants.DeleteToolkitAndImage.DeleteToolkit) && parseInt(courseObj.DeleteToolKitAndImage) !== parseInt(constants.DeleteToolkitAndImage.DeleteToolkitAndImage))">
                        <a target="_blank" :href="ToolkitFileUrlValue" :disabled="(parseInt(courseObj.DeleteToolKitAndImage) !== parseInt(constants.DeleteToolkitAndImage.DeleteToolkit) && parseInt(courseObj.DeleteToolKitAndImage) !== parseInt(constants.DeleteToolkitAndImage.DeleteToolkitAndImage))">Toolkit File</a>
                      </span>
                      <span v-else class="text-color-red">Deleted</span>
                    </div>
                    <div class="col-sm-9">
                      <input type="file" id="toolkitfile" accept=".pdf">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-15px col-md-8 col-lg-8 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-3 font-size-14px" v-if="ToolkitFileUrlValue !== null && ToolkitFileUrlValue !== undefined">
                      <span class="cursor-pointer" @click="peformUserClickAction('Delete_Toolkit')" :class="{'opacity-point-5 cursor-default' : (courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkit || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}">Delete </span>|
                      <span class="cursor-pointer" @click="peformUserClickAction('Reset_Toolkit')" :class="{'opacity-point-5 cursor-default' : !(courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkit || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}"> Restore</span>
                    </div>
                    <div class="col-sm-9"></div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-left-0Perc">
                  <span v-if="isComingFrom === constants.CourseSearchBarEnum.Course">Lesson Numbering</span>
                </div>
                <div class="font-size-15px col-md-4 col-lg-4 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                      <select class="form-control" v-model="lessonNumberingValue">
                        <option value=0>Default</option>
                        <option value=1>Custom</option>
                        <option value=2>Hide</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="font-size-15px col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <span @click="openCourseDescOverlay($event, true)" class="cursor-pointer">+Add Course Description</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Course Image
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="col-sm-12">
                    <img :src="CourseImageUrlValue" class="course-img-width-height" id="courseImg" :class="{'opacity-point-2' : (courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}" @error="assignDefaultImage" @load="imageLoadedSuccessfully"/>
                    <!-- <span v-if="(courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)">Deleted</span> -->
                  </div>
                </div>
                <div class="col-md-5 col-lg-5">
                  <div class="col-sm-12 padding-left-4Point4">
                    <input type="file" id="selectedCourseFile" accept=".jpg, .jpeg, .png"/>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course && showCourseImgDeleteOption"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-15px col-md-8 col-lg-8 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-5 font-size-14px">
                      <span class="cursor-pointer" @click="peformUserClickAction('Download_Course_Img')" :class="{'opacity-point-5 cursor-default' : (courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}">Download </span>|
                      <span class="cursor-pointer" @click="peformUserClickAction('Delete_Course_Img')" :class="{'opacity-point-5 cursor-default' : (courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}">Delete </span>|
                      <span class="cursor-pointer" @click="peformUserClickAction('Reset_Course_Img')" :class="{'opacity-point-5 cursor-default' : !(courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)}"> Restore</span>
                    </div>
                    <div class="col-sm-7"></div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateCourse($event)">Update Course</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <add-rtf-course-description-overlay v-if="openDescriptionOverlay" @closeRtfEditorOverlay="closeRTFEditor" :addedDescription="courseObj.Description"></add-rtf-course-description-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import {findIndex} from 'lodash'
import { courseService } from '@/server-util/course-service'
import AlertBox from '@/components/AlertOverlay'
import ErrorImage from '../assets/images/imagenotfound.svg'
import AddRTFCourseDescriptionOverlay from '@/components/AddRTFCourseDescriptionOverlay'
export default {
  props: ['selectedCourseObj', 'isComingFrom'],
  name: 'edit-course-details',
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      courseObj: {
        CourseMasterId: '',
        CourseTitle: '',
        SubTitle: '',
        IsEnabled: true,
        Type: 0,
        Version: '',
        LessonNumbering: 2,
        Description: null,
        DeleteToolKitAndImage: constants.DeleteToolkitAndImage.None
      },
      showCourseImgDeleteOption: false,
      reAssignedDefaultImg: false,
      showAlertDialog: false,
      errorMsg: '',
      titleMaxLength: constants.Course_Title_Max_Length,
      subTitleMaxLength: constants.Course_Sub_Title_Max_Length,
      openDescriptionOverlay: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'add-rtf-course-description-overlay': AddRTFCourseDescriptionOverlay
  },
  methods: {
    imageLoadedSuccessfully: function () {
      if (!this.reAssignedDefaultImg) {
        this.showCourseImgDeleteOption = true
        console.log('imageLoadedSuccessfully')
      }
    },
    peformUserClickAction: function (operationName) {
      switch (operationName) {
        default:
          this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.None
          break
        case 'Delete_Toolkit':
          if (!(this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkit || this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)) {
            if (this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage) {
              this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteToolkitAndImage
            } else {
              this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteToolkit
            }
          } else {
            console.log('Ignored')
          }
          break
        case 'Reset_Toolkit':
          if ((this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkit || this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)) {
            if (this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage) {
              this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteImage
            } else {
              this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.None
            }
          } else {
            console.log('Ignored')
          }
          break
        case 'Download_Course_Img':
          if (!(this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteImage || this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage)) {
            var pom = document.createElement('a')
            pom.setAttribute('href', 'data:application/octet-stream,' + encodeURIComponent(this.CourseImageUrlValue))
            pom.setAttribute('download', this.getCurrentCourseObj.CourseTitle)
            pom.style.display = 'none'
            document.body.appendChild(pom)
            pom.click()
            document.body.removeChild(pom)
          } else {
            console.log('Ignored')
          }
          break
        case 'Delete_Course_Img':
          if (this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkit) {
            this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteToolkitAndImage
          } else {
            this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteImage
          }
          break
        case 'Reset_Course_Img':
          if (this.courseObj.DeleteToolKitAndImage === constants.DeleteToolkitAndImage.DeleteToolkitAndImage) {
            this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.DeleteToolkit
          } else {
            this.courseObj.DeleteToolKitAndImage = constants.DeleteToolkitAndImage.None
          }
          break
      }
    },
    closeRTFEditor (value) {
      this.openDescriptionOverlay = value.closeRtfEditorOverlay
      this.courseObj.Description = value.description
    },
    openCourseDescOverlay: function (event, flagToUpdate = false) {
      this.openDescriptionOverlay = flagToUpdate
    },
    setDefaultValues: function () {
      this.courseObj.CourseMasterId = this.getCurrentCourseObj.CourseMasterId
      this.courseObj.Type = this.getCurrentCourseObj.Type
      this.courseObj.CourseTitle = this.getCurrentCourseObj.CourseTitle
      this.courseObj.SubTitle = this.getCurrentCourseObj.SubTitle
      this.courseObj.Description = this.getCurrentCourseObj.Description
      this.courseObj.IsEnabled = this.getCurrentCourseObj.IsEnabled
      this.courseObj.Type = this.getCurrentCourseObj.Type
      this.courseObj.Version = this.getCurrentCourseObj.Version
      this.courseObj.LessonNumbering = this.getCurrentCourseObj.LessonNumbering
      this.courseObj.Description = this.getCurrentCourseObj.Description
      this.courseObj.ToolkitFileUrl = this.getCurrentCourseObj.ToolkitFileUrl
    },
    udpateCloseEditCourseDetailOverlay: function (event) {
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = false
      this.$emit('closeEditCourse', false)
    },
    assignDefaultImage: function (event) {
      this.showCourseImgDeleteOption = false
      this.reAssignedDefaultImg = true
      document.getElementById('courseImg').src = ErrorImage
    },
    checkCourseImageExtension: function (fileName) {
      if (this.isComingFrom === constants.CourseSearchBarEnum.Course) {
        var exts = ['.jpg', '.jpeg', '.png']
        return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
          fileName
        )
      } else {
        return true
      }
    },
    checkToolkitFileExtesion: function (fileName) {
      if (this.isComingFrom === constants.CourseSearchBarEnum.Course) {
        var exts = ['.pdf']
        return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
          fileName
        )
      } else {
        return true
      }
    },
    updateCourse: function (event) {
      const formData = new FormData()

      formData.append('CourseMasterId', this.courseObj.CourseMasterId)

      var courseImg = (this.isComingFrom === constants.CourseSearchBarEnum.Course) ? document.getElementById('selectedCourseFile').files[0] : undefined
      var toolkitFile = (this.isComingFrom === constants.CourseSearchBarEnum.Course) ? document.getElementById('toolkitfile').files[0] : undefined

      if (this.courseObj.CourseTitle === '') {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return
      } else {
        formData.append('CourseTitle', this.courseObj.CourseTitle)
      }
      if (this.isComingFrom === constants.CourseSearchBarEnum.Course && (toolkitFile !== undefined) && (!this.checkToolkitFileExtesion(document.getElementById('toolkitfile').value))) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid file format detected. You need to use a .pdf file.'
        return
      }
      formData.append('ToolkitFile', (this.isComingFrom === constants.CourseSearchBarEnum.Course && (toolkitFile !== undefined) && (this.checkToolkitFileExtesion(document.getElementById('toolkitfile').value))) ? toolkitFile : null)
      if ((courseImg !== undefined) && (!this.checkCourseImageExtension(document.getElementById('selectedCourseFile').value))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select .jpg, .jpeg or .png file.'
        return
      }
      formData.append('CourseImage', (this.isComingFrom === constants.CourseSearchBarEnum.Course && (courseImg !== undefined) && (this.checkCourseImageExtension(document.getElementById('selectedCourseFile').value))) ? courseImg : null)
      formData.append('SubTitle', this.courseObj.SubTitle)
      formData.append('DeleteToolKitAndImage', this.courseObj.DeleteToolKitAndImage)
      formData.append('IsEnabled', this.courseObj.IsEnabled)
      formData.append('Type', this.courseObj.Type)
      formData.append('Version', this.courseObj.Version)
      formData.append('LessonNumbering', this.courseObj.LessonNumbering)
      formData.append('Description', this.courseObj.Description)
      var _this = this
      var storeObj = this.$store
      if (formData !== undefined && formData !== '' && formData !== undefined) {
        // AK: Start showing spinner (Course file)
        _this.$emit('showSpinner', true)
        courseService
          .updateCourseMaster(storeObj.state.access_token, formData)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.checkAndUpdateGivenObjIntoGlobalList(responseObj.data, this.courseObj.CourseMasterId)
                // _this.$emit('refreshCourseList', true)
                _this.$store.state.isOverlayVisible = false
                _this.$emit('showSpinner', false)
                _this.$emit('closeEditCourse', false)
              } else {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected FormData is NULL hence declined Update COURSE OPERATION'
        )
      }
    },
    checkAndUpdateGivenObjIntoGlobalList: function (updatedObj, currentCourseMasterId) {
      let foundIndex = findIndex(this.$store.state.course_list, (obj) => {
        return obj.CourseMasterId === currentCourseMasterId
      })
      var tempCourseList = this.$store.state.course_list
      if (foundIndex > -1) {
        this.$store.state.course_list = []
        tempCourseList[foundIndex] = updatedObj
        this.$store.state.course_list = tempCourseList
      }
      foundIndex = findIndex(this.$store.state.recAssessmentList, (obj) => {
        return obj.CourseMasterId === currentCourseMasterId
      })
      tempCourseList = this.$store.state.recAssessmentList
      if (foundIndex > -1) {
        this.$store.state.recAssessmentList = []
        tempCourseList[foundIndex] = updatedObj
        this.$store.state.recAssessmentList = tempCourseList
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getRandomNumber: function () {
      return Math.random()
    }
  },
  computed: {
    getCurrentCourseObj: {
      get: function () {
        return this.selectedCourseObj
      }
    },
    CourseTitleValue: {
      get: function () {
        return this.courseObj.CourseTitle
      },
      set: function (newValue) {
        this.courseObj.CourseTitle = newValue
      }
    },
    CourseTypeValue: {
      get: function () {
        return this.courseObj.Type
      },
      set: function (newValue) {
        this.courseObj.Type = newValue
      }
    },
    lessonNumberingValue: {
      get: function () {
        return this.courseObj.LessonNumbering
      },
      set: function (newValue) {
        this.courseObj.LessonNumbering = newValue
      }
    },
    CourseSubTitleValue: {
      get: function () {
        return this.courseObj.SubTitle
      },
      set: function (newValue) {
        this.courseObj.SubTitle = newValue
      }
    },
    CourseVersionValue: {
      get: function () {
        return this.courseObj.Version
      },
      set: function (newValue) {
        this.courseObj.Version = newValue
      }
    },
    IsEnabledCourseValue: {
      get: function () {
        return this.courseObj.IsEnabled
      },
      set: function (newValue) {
        this.courseObj.IsEnabled = newValue
      }
    },
    ToolkitFileUrlValue: {
      get: function () {
        return this.courseObj.ToolkitFileUrl
      }
    },
    CourseMasterIdValue: {
      get: function () {
        return this.courseObj.CourseMasterId
      }
    },
    CourseImageUrlValue: {
      get: function () {
        return server.baseURL() + '/api/CourseMaster/CourseImage?CourseMasterId=' + this.CourseMasterIdValue + '&' + Math.random()
      }
    }
  }
}
</script>

<style scoped>
.text-align-center {
  text-align: center !important;
}
.cursor-default {
  cursor: default !important;
}
.opacity-point-5 {
  opacity: 0.5;
}
.opacity-point-2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-15px {
  font-size: 15px !important;
}
.font-size-14px {
  font-size: 14px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.text-color-red {
  color: red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  margin-left: 4.4% !important;
}
a:link{
  /* color: #2c3e50 !important; */
  color: #0000FF !important;
  text-decoration: none !important;
} 
a:visited{
  /* color: #2c3e50 !important; */
  color: #0000FF !important;
  text-decoration: none !important;
}
a:hover{
  /* color: #2c3e50 !important; */
  color: #0000FF !important;
  text-decoration: underline !important;
}
a:active{
  /* color: #2c3e50 !important; */
  color: #0000FF !important;
  text-decoration: none !important;
}
a {
  /* color: #2c3e50 !important; */
  color: #0000FF !important;
  text-decoration: none !important;
}
.padding-right-0Point5Perc{
  padding-right: 0.5%;
}
.border-red {
  border: 1px solid red;
}
.padding-left-0Perc {
  padding-left:0%;
}

</style>


// WEBPACK FOOTER //
// src/components/EditCourseDetailOverlay.vue